import { ComposedElement } from "../ComposedElement.mjs";
export var ParagraphNode;

(function (ParagraphNode) {
  ParagraphNode.TYPE = 'paragraph';

  function isParagraphNode(value) {
    return ComposedElement.isComposedElement(value, ParagraphNode.TYPE);
  }

  ParagraphNode.isParagraphNode = isParagraphNode;

  function validateParagraphNode(value, validateChildNode) {
    var isValid = ComposedElement.validateComposedElement(value, ParagraphNode.TYPE, validateChildNode);
    return isValid ? value : null;
  }

  ParagraphNode.validateParagraphNode = validateParagraphNode;
})(ParagraphNode || (ParagraphNode = {}));